import { useState } from 'react'

import { Category } from '../../models/Category'
import Button from '../app/design/Button'
import Modal from '../app/design/Modal'
import { Checkbox } from '../common/fields/Checkbox'
import { TextArea } from '../common/fields/TextArea'
import { TextField } from '../common/fields/TextField'
import { WorkflowPage } from '../workflows/WorkflowPage'

type Props = {
    isOpen: boolean
    onClose: () => void
    category: Category
    onDone: (updatedCategory: Category) => void
    onMoreDetails?: () => void
    title: string
    shouldShowPublicField: boolean
}

export const CategoryLiteModal = ({
    isOpen,
    onClose,
    category,
    onDone,
    onMoreDetails,
    title,
    shouldShowPublicField,
}: Props) => {
    const [name, setName] = useState(category.name ?? '')
    const [memo, setMemo] = useState(category.memo ?? '')
    const [isPublic, setIsPublic] = useState(category.isPublic ?? true)

    const handleDone = () => {
        onDone(
            category.clone({
                name,
                memo,
                is_public: isPublic,
            })
        )
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            footer={
                <div className="flex w-full items-center justify-end gap-x-4">
                    {onMoreDetails !== undefined && (
                        <Button intent="secondary" onClick={onMoreDetails}>
                            Show more details
                        </Button>
                    )}
                    <Button onClick={handleDone} intent="primary">
                        Save
                    </Button>
                </div>
            }
            width={744}
        >
            <div className="flex flex-col items-stretch justify-start gap-y-8">
                <WorkflowPage.IconSection title="Name (required)" icon="grid.large">
                    <TextField
                        size="medium"
                        placeholder="Name"
                        value={name ?? ''}
                        onChange={(event) => setName(event.target.value)}
                        onClear={() => setName('')}
                    />
                </WorkflowPage.IconSection>

                <WorkflowPage.IconSection title="Description" icon="note.large">
                    <TextArea
                        size="medium"
                        placeholder="Enter description"
                        value={memo ?? ''}
                        onChange={(event) => setMemo(event.target.value)}
                        onClear={() => setMemo('')}
                        isAutoResizing
                    />
                </WorkflowPage.IconSection>

                {shouldShowPublicField && (
                    <WorkflowPage.IconSection
                        title="Show online"
                        icon="computerDollar.large"
                        hasHoverEffect
                        secondaryView={<Checkbox isChecked={isPublic} onChange={setIsPublic} />}
                    />
                )}
            </div>
        </Modal>
    )
}
